import { AdminMembersReportPageStartDate } from "@/admin/insights/member-reports/AdminMembersReportPage"
import AdminMembersReportDailyDiscussionsSection from "@/admin/insights/member-reports/tabs/AdminMembersReportDailyDiscussionsSection"
import AdminMembersReportChannelsTable from "@/admin/insights/member-reports/tabs/discussions/AdminMembersReportChannelsTable"
import AdminMembersReportDiscussionsTabStatisticsCards from "@/admin/insights/member-reports/tabs/discussions/AdminMembersReportDiscussionsTabStatisticsCards"
import AdminMembersReportFeedsTable from "@/admin/insights/member-reports/tabs/discussions/AdminMembersReportFeedsTable"

interface AdminMembersReportPageDiscussionsTabProps {
  startDate: AdminMembersReportPageStartDate
}

function AdminMembersReportPageDiscussionsTab({
  startDate,
}: AdminMembersReportPageDiscussionsTabProps) {
  return (
    <>
      <AdminMembersReportDiscussionsTabStatisticsCards filters={{ startDate }} />
      <AdminMembersReportDailyDiscussionsSection filters={{ startDate }} />
      <AdminMembersReportChannelsTable />
      <AdminMembersReportFeedsTable />
    </>
  )
}

export default AdminMembersReportPageDiscussionsTab
